// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class LocationType {
    public static readonly REGIONAL: number = 1;
    public static readonly STATE: number = 2;
    public static readonly NATIONAL: number = 3;
}
